import spiderman from '@/spiderman/index';

const { axios, api } = spiderman;

async function send(member, memberInfo, postForm) {
  return (
    await axios.post(api.visitorRegistrations,
      {
        clinic: member.info.clinic,
        ...memberInfo,
        registration: postForm,
      },
      {
        headers: {
          jwt: member.jwt,
        },
      })
  ).data;
}

export default {
  send,
};
